import React, { useEffect, useState, useMemo } from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useSelector } from 'react-redux';
import { useGetUserParamsQuery } from '../../api/endpoints/user';
import { selectUserParams, selectLanguageId, selectUserEmail } from '../../store/slices/userParamsSlice';


const UserParams = () => {
  const { data: response, isLoading, error, refetch } = useGetUserParamsQuery();
  const userParamsFromStore = useSelector(selectUserParams);
  const languageId = useSelector(selectLanguageId);
  const userEmail = useSelector(selectUserEmail);

  const userParams = userParamsFromStore || response || {};

  const dealerId = useMemo(
    () => userParams?.dealerId ?? userParams?.DealerId ?? null,
    [userParams]
  );

  const [showDealerDlg, setShowDealerDlg] = useState(false);

  // Sayfa açılınca dealerId varsa dialog’u otomatik aç
  useEffect(() => {
    if (dealerId) setShowDealerDlg(true);
  }, [dealerId]);

  const getLanguageText = (langId) => {
    if (langId === 2) return 'TR';
    if (langId === 1) return 'EN';
    return langId?.toString() || '';
  };

  const handleRefresh = () => {
    refetch();
  };

  if (error) {
    return (
      <Card title="Kullanıcı Bilgileri" className="m-3">
        <div className="text-center p-4">
          <i className="pi pi-exclamation-triangle text-red-500 text-4xl mb-3"></i>
          <p className="text-red-500">
            Veri yüklenirken bir hata oluştu: {error.data?.message || error.message || 'Bilinmeyen hata'}
          </p>
          <Button label="Tekrar Dene" icon="pi pi-refresh" onClick={handleRefresh} />
        </div>
      </Card>
    );
  }

  if (isLoading) {
    return (
      <Card title="Kullanıcı Bilgileri" className="m-3">
        <div className="text-center p-4">
          <i className="pi pi-spin pi-spinner text-blue-500 text-4xl mb-3"></i>
          <p>Kullanıcı bilgileri yükleniyor...</p>
        </div>
      </Card>
    );
  }

  return (
    <>
      <div className="grid">
        <div className="col-12">
          <Card className="card">
            <div className="grid">
              <div className="col-12 md:col-4">
                <div className="grid">
                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_LANGUAGE</label>
                    <InputText value={getLanguageText(languageId)} disabled className="w-full" />
                  </div>

                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_USER_ID</label>
                    <InputText value={userParams.userId?.toString() || ''} disabled className="w-full" />
                  </div>

                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_USER_NAME</label>
                    <InputText value={userParams.dealerFullName || 'Sefa Öztürk'} disabled className="w-full" />
                  </div>

                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_REQUESTED_DATE_ALLOW</label>
                    <InputText value="2" disabled className="w-full" />
                  </div>

                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_BRANCH_DISCOUNT</label>
                    <InputText value="29" disabled className="w-full" />
                  </div>
                </div>
              </div>

              <div className="col-12 md:col-4">
                <div className="grid">
                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_BRANCH_ID</label>
                    <InputText value={dealerId?.toString() || ''} disabled className="w-full" />
                  </div>

                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_BRANCH_SITE_ID</label>
                    <InputText value={userParams.siteUseId?.toString() || ''} disabled className="w-full" />
                  </div>

                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_ADDR_ID</label>
                    <InputText value={userParams.addrId?.toString() || ''} disabled className="w-full" />
                  </div>

                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_USER_EMAIL</label>
                    <InputText value={userEmail || ''} disabled className="w-full" />
                  </div>

                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_HIDE_PRICE</label>
                    <InputText value="1" disabled className="w-full" />
                  </div>
                </div>
              </div>

              <div className="col-12 md:col-4">
                <div className="grid">
                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_CUSTOM_USER_ID</label>
                    <InputText value={userParams.sapDealerId?.toString() || ''} disabled className="w-full" />
                  </div>

                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_BRANCH_NAME</label>
                    <InputText value={userParams.dealerFullName || 'KAR3S'} disabled className="w-full" />
                  </div>

                  <div className="col-12">
                    <div className="flex align-items-end gap-2">
                      <div className="flex-1">
                        <label className="block text-900 font-medium mb-2">APP_ANNOUNCEMENT_COUNT</label>
                        <InputText value="0" disabled className="w-full" />
                      </div>

                    </div>
                  </div>

                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_USAGE_TYPE</label>
                    <InputText value={userParams.usageType?.toString() || ''} disabled className="w-full" />
                  </div>

                  <div className="col-12">
                    <label className="block text-900 font-medium mb-2">APP_DISCOUNT_INF</label>
                    <InputText value="1" disabled className="w-full" />
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default UserParams;

